import React from 'react';
import PropTypes from 'prop-types';
import clx from 'classnames';
import { Button } from '@chakra-ui/react';
import {
  CheckCircle,
  FacebookMessenger,
} from '../../pages/context/Chakra/Icons';

const FacebookSubscriptionButton = ({
  children,
  className,
  isSubscribed = false,
  isLoading = false,
  e2eId,
  onClick,
}) => {
  return (
    <Button
      className={clx(
        'facebook-subscription-button',
        {
          'facebook-subscription-button_subscribed': isSubscribed,
        },
        className,
      )}
      type="button"
      variant="outline"
      isLoading={isLoading}
      onClick={onClick}
      data-e2e-id={e2eId}
    >
      {isSubscribed ? <CheckCircle color="#0584FF" /> : <FacebookMessenger />}
      {children}
    </Button>
  );
};

FacebookSubscriptionButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isSubscribed: PropTypes.bool,
  e2eId: PropTypes.string,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
};

export default FacebookSubscriptionButton;
